// @flow
import type { Firestore } from '../types/firebase';
import _createModel from './_model';

export default (firestore?: Firestore) => _createModel(firestore, {
    collection: 'cars',
    idKey: 'icao'
});